let isPC = function () {
  var userAgentInfo = navigator.userAgent.toLowerCase()
  var Agents = ['android', 'iphone', 'symbianos', 'windows phone', 'ipad', 'ipod', 'iphone os', 'midp', 'ucweb', 'windows ce', 'windows mobile', 'harmonyos']
  var flag = true
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false
      break
    }
  }
  return flag
}

export { isPC }



// WEBPACK FOOTER //
// ./src/utils/getIsPC.js